import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Subject } from 'rxjs/Subject';
import 'rxjs/add/operator/map';
import { CurrentAccount } from '../app/models/CurrentAccount';
import { User } from '../app/models/User';
import { ConfigService } from '../providers/config/config.service';
import { GenericQueryParams } from '../utils/utils';
import { CommonService, GenericPaginatedDataType } from './common.service';

export type GetUsersType = GenericPaginatedDataType<User>;

@Injectable()
export class UserService {
  private users: Subject<User[]>;

  constructor(private configService: ConfigService, private commonService: CommonService) {
    this.users = new Subject<any>();
    this.users.next([]);
  }

  getUser(uuid: String): Observable<User> {
    let url = this.configService.getUrl() + 'users/' + uuid;
    type typeToReturn = User;
    let response = this.commonService.getData<typeToReturn>(url);
    return response;
  }

  getUserByUsername(username: String): Observable<User> {
    let url = this.configService.getUrl() + 'users/user?username=' + username;
    type typeToReturn = User;
    let response = this.commonService.getData<typeToReturn>(url);
    return response;
  }

  getUsers(): Observable<User[]> {
    let url = this.configService.getUrl() + 'users';
    type typeToReturn = User[];

    let response = this.commonService.getData<typeToReturn>(url);
    return response;
  }

  getPaginatedUsers(params: GenericQueryParams) {
    return this.commonService.getPaginatedQuery<GetUsersType>('users', params);
  }

  getUserByCurrentAccount(currentAccount: CurrentAccount) {
    let url = this.configService.getUrl() + 'currentaccounts/' + currentAccount.uuid + '/user';
    type typeToReturn = User;
    let response = this.commonService.getData<typeToReturn>(url);
    return response;
  }
}



// WEBPACK FOOTER //
// ./src/services/user.service.ts